import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import {HelpModalComponent} from '@shared/components/help-modal/help-modal.component';
import {HeaderComponent} from '@shared/components/header/header.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from '@shared/components';
import {AddressComponent} from '@shared/components/contact-info/address/address.component';
import {PersonalInfoComponent} from '@shared/components/contact-info/personal-info/personal-info.component';
import {PhoneNumberComponent} from '@shared/components/contact-info/phone-number/phone-number.component';
import {NotFoundComponent} from '@shared/components/not-found/not-found.component';
import {PrivacyPolicyModalComponent} from '@shared/components/privacy-policy-modal/privacy-policy-modal.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NumberOnlyDirective} from '@shared/directives/numberOnly.directive';
import {Ng2TelInputModule} from 'ng2-tel-input';

/**
 * SharedModule is a conventional name for an NgModule with components that are used accross
 * the entire application, including feature modules that are possibly lazy loaded.
 *
 * IMPORTANT: This module should NOT expose global singleton services.  This would create duplicate services in lazy loaded modules.
 * Please put global singleton services in the CoreModule.
 */

const COMPONENTS = [
  LoginComponent,
  NotFoundComponent,
  PrivacyPolicyModalComponent,
  AddressComponent,
  PersonalInfoComponent,
  PhoneNumberComponent,
  HeaderComponent,
  HelpModalComponent,
  NumberOnlyDirective,
  SafeHtmlPipe
];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2TelInputModule.forRoot(),
    NgSelectModule,
    NgbModule
  ],
  exports: COMPONENTS,
  entryComponents: [PrivacyPolicyModalComponent, HelpModalComponent]
})
export class SharedModule {
  constructor() {}
}
